import { create } from "zustand";

export interface TourPapers {
  inReview: number;
  completed: number;
  queued: number;
  ready: number;
}

interface TourState {
  active: boolean;
  projectId: number | null;
  papers: TourPapers | null;
  start: (projectId: number, papers: TourPapers) => void;
  end: () => void;
}

export const useTourStore = create<TourState>((set) => ({
  active: false,
  projectId: null,
  papers: null,
  start: (projectId, papers) => set({ active: true, projectId, papers }),
  end: () => set({ active: false, projectId: null, papers: null }),
}));
